<template>
    <div v-if="loading">
        <SpinnerIOS/>
    </div>
    <div v-else class="container">
        <div class="row row-cols-1 row-cols-md-4 g-4 section-cards">
            <div class="col" v-for="gallery in dataGalarey" :key="gallery.id">
                <div
                    class="card h-100 shadow-sm border-0 rounded-3 overflow-hidden"
                    data-bs-toggle="modal"
                    :data-bs-target="'#modal-' + gallery.id"
                    style="cursor: pointer"
                    @click="openGallery(gallery.id)"
                >
                    <div class="position-relative">
                        <img
                            class="card-img-top"
                            :src="gallery.preview_image || '/media/default_thumbnail.jpg'"
                            :alt="gallery.description"
                            style="object-fit: cover; height: 180px;"
                        />
                        <div
                            class="overlay position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
                        >
                            <i class="bi bi-image text-white fs-3"></i>
                        </div>
                    </div>
                    <div class="card-body">
                        <h5 class="card-title text-truncate fw-bold" :title="gallery.description">
                            {{
                                gallery.description.length > 50
                                    ? gallery.description.slice(0, 50) + '...'
                                    : gallery.description
                            }}
                        </h5>
                    </div>
                    <div class="card-footer bg-transparent border-0">
                        <small class="text-muted">{{ formatDate(gallery.created_at) }}</small>
                    </div>
                </div>
            </div>
        </div>
        <nav v-if="pagination.totalPages > 1" class="mt-4 d-flex justify-content-center">
            <ul class="pagination">
                <li class="page-item" :class="{ disabled: pagination.currentPage === 1 }">
                    <a class="page-link" href="#" @click.prevent="changePage(pagination.currentPage - 1)">
                        <i class="bi bi-skip-backward"></i>
                    </a>
                </li>
                <li
                    class="page-item"
                    v-for="(page, index) in paginationPages"
                    :key="index"
                    :class="{ active: page === pagination.currentPage, disabled: page === '...' }"
                >
                    <a v-if="page !== '...'" class="page-link" href="#" @click.prevent="changePage(page)">{{ page }}</a>
                    <span v-else class="page-link">...</span>
                </li>
                <li class="page-item" :class="{ disabled: pagination.currentPage === pagination.totalPages }">
                    <a class="page-link" href="#" @click.prevent="changePage(pagination.currentPage + 1)">
                        <i class="bi bi-skip-forward"></i>
                    </a>
                </li>
            </ul>
        </nav>
        <div
            v-for="gallery in dataGalarey"
            :key="'modal-' + gallery.id"
            class="modal fade"
            :id="'modal-' + gallery.id"
            tabindex="-1"
            aria-hidden="true"
        >
            <div class="modal-dialog modal-xl modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-body p-0 position-relative">
                        <button
                            type="button"
                            class="btn-close btn-sm custom-close-button position-absolute top-0 end-0 m-3 bg-secondary"
                            style="z-index: 1055"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        ></button>
                        <div v-if="!galleryImages[gallery.id]" class="text-center p-4">
                            <SpinnerIOS/>
                        </div>
                        <div v-else :id="'carousel-' + gallery.id" class="carousel slide">
                            <div class="carousel-indicators">
                                <button
                                    v-for="(item, index) in galleryImages[gallery.id]"
                                        :key="'indicator-' + item.id"
                                        type="button"
                                        :data-bs-target="'#carousel-' + gallery.id"
                                        :data-bs-slide-to="index"
                                        :class="{ active: index === 0 }"
                                        :aria-current="index === 0 ? 'true' : null"
                                        :aria-label="'Slide ' + (index + 1)"
                                ></button>
                            </div>
                            <div class="carousel-inner">
                                <div
                                    v-for="(item, index) in galleryImages[gallery.id]"
                                    :key="item.id"
                                    class="carousel-item"
                                    :class="{ active: index === 0 }"
                                >
                                    <img
                                        :src="item.image"
                                        class="d-block w-100"
                                        :alt="'Rasm ' + item.id"
                                        style="max-height: 80vh; object-fit: contain;"
                                    />
                                </div>
                            </div>
                            <button
                                class="carousel-control-prev"
                                type="button"
                                :data-bs-target="'#carousel-' + gallery.id"
                                data-bs-slide="prev"
                            >
                                <span class="carousel-control-prev-icon bg-secondary rounded-circle"
                                      aria-hidden="true"></span>
                                <span class="visually-hidden bg-secondary rounded-circle">Oldingi</span>
                            </button>

                            <button
                                class="carousel-control-next"
                                type="button"
                                :data-bs-target="'#carousel-' + gallery.id"
                                data-bs-slide="next"
                            >
                                <span class="carousel-control-next-icon bg-secondary rounded-circle"
                                      aria-hidden="true"
                                >
                                </span>
                                <span class="visually-hidden bg-secondary rounded-circle">Keyingi</span>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="carousel-caption d-none d-md-block bg-opacity-50 p-2 rounded">
                    <h5 class="mt-5">{{ gallery.description }}</h5>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from "@/api";
import SpinnerIOS from "@/components/SiteComponents/Main/Components/SpinnerIOS.vue";

export default {
    name: "FotoGalleryComponent",
    components: {SpinnerIOS},
    data() {
        return {
            loading: true,
            language: localStorage.getItem("language") || "uz",
            dataGalarey: [],
            galleryImages: {}, // Har bir galareya uchun rasmlar ob'ekti
            pagination: {
                currentPage: 1,
                totalPages: 1,
            },
        };
    },
    methods: {
        async fetchGalarey(page = 1) {
            this.loading = true;
            try {
                localStorage.setItem("currentPage", page);
                const {data} = await api.get(`/image-galleries/?page=${page}`, {
                    headers: {
                        "Accept-Language": this.language,
                    },
                });
                this.dataGalarey = data.results;
                this.pagination.currentPage = page;
                this.pagination.totalPages = Math.ceil(data.count / 12);
            } catch (error) {
                console.error("Xatolik:", error);
            } finally {
                this.loading = false;
            }
        },
        async fetchGalleryImages(galleryId) {
            try {
                const {data} = await api.get(`/image-galleries/${galleryId}/images/`, {
                    headers: {
                        "Accept-Language": this.language,
                    },
                });
                // Vue 3 da oddiy tayinlash reaktiv bo‘ladi
                this.galleryImages[galleryId] = data.images || [];
            } catch (error) {
                console.error("Rasm yuklashda xatolik:", error);
                this.galleryImages[galleryId] = []; // Xato bo‘lsa bo‘sh ro‘yxat
            }
        },
        openGallery(galleryId) {
            // Agar rasmlar hali yuklanmagan bo‘lsa, yuklash
            if (!(galleryId in this.galleryImages)) {
                this.fetchGalleryImages(galleryId);
            }
        },
        changePage(page) {
            if (page >= 1 && page <= this.pagination.totalPages) {
                localStorage.setItem("currentPage", page);
                this.fetchGalarey(page);
            }
        },
        formatDate(dateString) {
            if (!dateString) return "Sana mavjud emas";
            const date = new Date(dateString);
            if (isNaN(date)) return "Noto‘g‘ri sana";

            if (this.language === "uz") {
                const months = [
                    'yanvar', 'fevral', 'mart', 'aprel', 'may', 'iyun',
                    'iyul', 'avgust', 'sentyabr', 'oktyabr', 'noyabr', 'dekabr'
                ];
                const day = date.getDate();
                const month = months[date.getMonth()];
                const year = date.getFullYear();
                return `${day}-${month}, ${year}`;
            }

            const options = {year: "numeric", month: "long", day: "numeric"};
            const locale = this.language === "ru" ? "ru-RU" : "en-US";
            return new Intl.DateTimeFormat(locale, options).format(date);
        },
    },
    mounted() {
        const savedPage = parseInt(localStorage.getItem("currentPage")) || 1;
        this.fetchGalarey(savedPage);
    },
    computed: {
        paginationPages() {
            const total = this.pagination.totalPages;
            const current = this.pagination.currentPage;
            const delta = 2;
            const range = [];
            const rangeWithDots = [];
            let l;

            for (let i = 1; i <= total; i++) {
                if (i === 1 || i === total || (i >= current - delta && i <= current + delta)) {
                    range.push(i);
                }
            }

            for (let i of range) {
                if (l) {
                    if (i - l === 2) {
                        rangeWithDots.push(l + 1);
                    } else if (i - l !== 1) {
                        rangeWithDots.push("...");
                    }
                }
                rangeWithDots.push(i);
                l = i;
            }
            return rangeWithDots;
        },
    },
};
</script>

<style scoped>
.custom-close-button {
    width: 20px;
    height: 20px;
    border: none;
    border-radius: 50%;
    filter: invert(50);
    opacity: 1;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}

.custom-close-button:focus {
    outline: none;
    box-shadow: 0 0 0 3px #6c757d;;
}

.section-cards {
    opacity: 0;
    animation: fadeInUp 0.6s ease-out forwards;
    animation-delay: 0.2s;
}

.card {
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    cursor: pointer;
}

.card:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15) !important;
}

.card .position-relative {
    position: relative;
    overflow: hidden;
}

.card-img-top {
    transition: transform 0.3s ease;
    z-index: 1;
}

.card:hover .card-img-top {
    transform: scale(1.05);
    z-index: 1;
}

.overlay {
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s ease, background-color 0.3s ease;
    opacity: 0;
    z-index: 2;
}

.card:hover .overlay {
    opacity: 1;
    background-color: rgba(0, 0, 0, 0.4);
}

.card-title {
    font-size: 1.1rem;
    color: #212529;
}

.card-footer {
    padding-bottom: 1rem;
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(30px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@media (max-width: 768px) {
    .card-title {
        font-size: 1rem;
    }

    .card-img-top {
        height: 150px;
    }
}

/* Pagination styles (retained from original FotoGalleryComponent) */
.pagination {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 20px;
}

.page-item .page-link {
    color: #6c757d;
    border: 1px solid #dee2e6;
    margin: 0 4px;
    border-radius: 5px;
    transition: background-color 0.2s ease-in-out;
}

.page-item .page-link:hover {
    background-color: #e9ecef;
}

.page-item.active .page-link {
    background-color: #6c757d !important;
    color: white;
    border-color: #6c757d;
}

.page-item.disabled .page-link {
    color: #adb5bd;
    pointer-events: none;
    background-color: #f8f9fa;
}

.page-link:focus {
    box-shadow: none;
    outline: none;
    border: none;
}
</style>